export type { BlockNumberType } from "./BlockNumberType.js";
export * from "./errors.js";

import { equals as _equals } from "./equals.js";
import { from as _from } from "./from.js";
import { toBigInt as _toBigInt } from "./toBigInt.js";
import { toNumber as _toNumber } from "./toNumber.js";

export const from = _from;
export const toBigInt = _toBigInt;
export const toNumber = _toNumber;
export const equals = _equals;
